export default {
    routerList: [
        //========财务管理========
        {
            path: "/FM/receivableWriteOff",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/receivableWriteOff"], resolve),
            meta: {
                title: "应收核销总表",
                keepAlive: true,
            },
        },
        {
            path: "/FM/ClearingBill/:id",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/ClearingBill"], resolve),
            meta: {
                title: "生成对账单",
                keepAlive: true,
            },
        },
        {
            path: "/FM/OpenInvoice",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/OpenInvoice"], resolve),
            meta: {
                title: "新建开票",
                keepAlive: true,
            },
        },
        {
            path: "/FM/PayableDetails",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/PayableDetails"], resolve),
            meta: {
                title: "新建开票",
                keepAlive: true,
            },
        },
        {
            path: "/FM/OrderDetails/",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/OrderDetails"], resolve),
            meta: {
                title: "明细",
                keepAlive: true,
            },
        },

        {
            path: "/FM/PayableWriteoff",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/PayableWriteoff"], resolve),
            meta: {
                title: "应付核销总表",
                keepAlive: true,
            },
        },
        {
            path: "/FM/WaybillReceivable",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/WaybillReceivable"], resolve),
            meta: {
                title: "运单应收核销",
                keepAlive: true,
            },
        },
        {
            path: "/FM/UOF",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/Abnormal"], resolve),
            meta: {
                title: "异常单核销",
                keepAlive: true,
            },
        },
        {
            path: "/FM/Outbound",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/Outbound"], resolve),
            meta: {
                title: "外发单核销",
                keepAlive: true,
            },
        },
        {
            path: "/FM/Depart",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/Depart"], resolve),
            meta: {
                title: "发车单核销",
                keepAlive: true,
            },
        },
        {
            path: "/FM/FW/OtherIncome",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/OtherIncome"], resolve),
            meta: {
                title: "其他收入核销",
                keepAlive: true,
            },
        },
        {
            path: "/FM/FW/OtherExpenses",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/OtherExpenses"], resolve),
            meta: {
                title: "其他支出核销",
                keepAlive: true,
            },
        },
        {
            path: "/FM/VehicleCost",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/VehicleCost"], resolve),
            meta: {
                title: "车辆成本核销",
                keepAlive: true,
            },
        },
        {
            path: "/FM/BillWriteoff",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/BillWriteoff"], resolve),
            meta: {
                title: "对账单核销",
                keepAlive: true,
            },
        },
        {
            path: "/FM/OrderReceivable",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/OrderReceivable"], resolve),
            meta: {
                title: "订单应收",
                keepAlive: true,
            },
        },
        {
            path: "/FM/OrderPayable",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/OrderPayable"], resolve),
            meta: {
                title: "订单应付",
                keepAlive: true,
            },
        },
        {
            path: "/FM/CollectLoans",
            component: (resolve) => require(["@/pages/FinancialManagement/FinancialWriteOff/CollectLoans"], resolve),
            meta: {
                title: "代收贷款",
                keepAlive: true,
            },
        },
        {
            path: "/FM/MtExpenditure",
            component: (resolve) => require(["@/pages/FinancialManagement/ManageQuotes/MtExpenditure"], resolve),
            meta: {
                title: "费项类型维护",
                keepAlive: true,
            },
        },
        {
            path: "/FM/SetExpenditure",
            component: (resolve) => require(["@/pages/FinancialManagement/ManageQuotes/SetExpenditure"], resolve),
            meta: {
                title: "费项设置",
                keepAlive: true,
            },
        },
        // 报表
        {
            path: "/FM/CustomPL",
            component: (resolve) => require(["@/pages/FinancialManagement/ReportForms/CustomPL"], resolve),
            meta: {
                title: "客户损益表",
                keepAlive: true,
            },
        },
        {
            path: "/FM/TransportPL",
            component: (resolve) => require(["@/pages/FinancialManagement/ReportForms/TransportPL"], resolve),
            meta: {
                title: "运单损益表",
                keepAlive: true,
            },
        },
        {
            path: "/FM/VehiclePL",
            component: (resolve) => require(["@/pages/FinancialManagement/ReportForms/VehiclePL"], resolve),
            meta: {
                title: "车辆损益表",
                keepAlive: true,
            },
        },
        {
            path: "/FM/DepartPL",
            component: (resolve) => require(["@/pages/FinancialManagement/ReportForms/DepartPL"], resolve),
            meta: {
                title: "部门损益表",
                keepAlive: true,
            },
        },
        {
            path: "/FM/DriverEscort",
            component: (resolve) => require(["@/pages/FinancialManagement/ReportForms/DriverEscort"], resolve),
            meta: {
                title: "司机押运费用统计",
                keepAlive: true,
            },
        },
        {
            path: "/FM/StevedoreCost",
            component: (resolve) => require(["@/pages/FinancialManagement/ReportForms/StevedoreCost"], resolve),
            meta: {
                title: "装卸员装卸费用清单",
                keepAlive: true,
            },
        },
        {
            path: "/FM/TransportFare",
            component: (resolve) => require(["@/pages/FinancialManagement/ReportForms/TransportFare"], resolve),
            meta: {
                title: "运单车费分摊清单",
                keepAlive: true,
            },
        },
        {
            path: "/FM/BillsDetailed",
            component: (resolve) => require(["@/pages/FinancialManagement/ReportForms/BillsDetailed"], resolve),
            meta: {
                title: "应收账款明细",
                keepAlive: true,
            },
        },
        {
            path: "/FM/OutboundDetailed",
            component: (resolve) => require(["@/pages/FinancialManagement/ReportForms/OutboundDetailed"], resolve),
            meta: {
                title: "外发应付账款明细",
                keepAlive: true,
            },
        },
        {
            path: "/FM/InviteDetailed",
            component: (resolve) => require(["@/pages/FinancialManagement/ReportForms/InviteDetailed"], resolve),
            meta: {
                title: "外请应付账款明细",
                keepAlive: true,
            },
        },
        {
            path: "/FM/VehicleStowage",
            component: (resolve) => require(["@/pages/FinancialManagement/ReportForms/VehicleStowage"], resolve),
            meta: {
                title: "车辆配载",
                keepAlive: true,
            },
        },
        // 资金管理
        {
            path: "/FM/FundAccountNo",
            component: (resolve) => require(["@/pages/FinancialManagement/FAMS/FundAccountNo"], resolve),
            meta: {
                title: "资金账号",
                keepAlive: true,
            },
        },
        {
            path: "/FM/FundAllocation",
            component: (resolve) => require(["@/pages/FinancialManagement/FAMS/FundAllocation"], resolve),
            meta: {
                title: "资金调拨",
                keepAlive: true,
            },
        },
        {
            path: "/FM/CapitalDaybook",
            component: (resolve) => require(["@/pages/FinancialManagement/FAMS/CapitalDaybook"], resolve),
            meta: {
                title: "资金流水账",
                keepAlive: true,
            },
        },
        // 其他收入
        {
            path: "/FM/OtherIncome",
            component: (resolve) => require(["@/pages/FinancialManagement/OtherIncome"], resolve),
            meta: {
                title: "其他收入",
                keepAlive: true,
            },
        },
        {
            path: "/FM/NewOtherIncome",
            component: (resolve) => require(["@/pages/FinancialManagement/OtherIncomeMOD/NewOtherIncome"], resolve),
            meta: {
                title: "新建其他收入",
                keepAlive: true,
            },
        },
        // 其他支出
        {
            path: "/FM/OtherExpenses",
            component: (resolve) => require(["@/pages/FinancialManagement/OtherExpenses"], resolve),
            meta: {
                title: "其他支出",
                keepAlive: true,
            },
        },
        {
            path: "/FM/NewOtherExpenses/:id",
            component: (resolve) => require(["@/pages/FinancialManagement/OtherExpensesMOD/NewOtherExpenses"], resolve),
            meta: {
                title: "新建其他支出",
                keepAlive: true,
            },
        },
        // 应收应付审核总表
        {
            path: "/FM/ARAPSummary",
            component: (resolve) => require(["@/pages/FinancialManagement/ARAPSummary"], resolve),
            meta: {
                title: "应收应付审核总表",
                keepAlive: true,
            },
        },
        // 发票管理
        {
            path: "/FM/InvoicesControl",
            component: (resolve) => require(["@/pages/FinancialManagement/InvoicesControl"], resolve),
            meta: {
                title: "发票管理",
                keepAlive: true,
            },
        },
        {
            path: "/FM/InvoicesAdd/:id",
            component: (resolve) => require(["@/pages/FinancialManagement/InvoicesControlMOD/InvoicesAddRX"], resolve),
            meta: {
                title: "开票",
                keepAlive: true,
            },
        },
        //  客商管理
        // -----合世
        // {
        //     path: "/Customers/NVOCC",
        //     component: (resolve) => require(["@/pages/Customers/NVOCC"], resolve),
        //     meta: {
        //         title: "承运商档案",
        //         keepAlive: true,
        //     },
        // },
        // {
        //     path: "/Customers/NVOCCMOD/Create",
        //     component: (resolve) => require(["@/pages/Customers/NVOCCMOD/Create"], resolve),
        //     meta: {
        //         title: "新建承运商档案",
        //         keepAlive: true,
        //     },
        // },
        // {
        //     path: "/Customers/NVOCCMOD/Edit",
        //     component: (resolve) => require(["@/pages/Customers/NVOCCMOD/ModifyPage"], resolve),
        //     meta: {
        //         title: "修改承运商档案",
        //         keepAlive: true,
        //     },
        // },
        // -----合世
        {
            path: "/Customers/NVOCC",
            component: (resolve) => require(["@/pages/Customers/NVOCCRX"], resolve),
            meta: {
                title: "承运商档案",
                keepAlive: true,
            },
        },
        {
            path: "/Customers/NVOCCMOD/Create",
            component: (resolve) => require(["@/pages/Customers/NVOCCMODRX/Create"], resolve),
            meta: {
                title: "新建承运商档案",
                keepAlive: true,
            },
        },
        {
            path: "/Customers/NVOCCMOD/Edit",
            component: (resolve) => require(["@/pages/Customers/NVOCCMODRX/ModifyPage"], resolve),
            meta: {
                title: "修改承运商档案",
                keepAlive: true,
            },
        },
        {
            path: "/Customers/Custom",
            component: (resolve) => require(["@/pages/Customers/Custom"], resolve),
            meta: {
                title: "客户档案",
                keepAlive: true,
            },
        },
        {
            path: "/Customers/CustomMOD/Create",
            component: (resolve) => require(["@/pages/Customers/CustomMOD/Create"], resolve),
            meta: {
                title: "新建客户档案",
                keepAlive: true,
            },
        },
        {
            path: "/Customers/CustomMOD/Edit",
            component: (resolve) => require(["@/pages/Customers/CustomMOD/Edit"], resolve),
            meta: {
                title: "修改客户档案",
                keepAlive: true,
            },
        },
        {
            path: "/Customers/Consignee",
            component: (resolve) => require(["@/pages/Customers/Consignee"], resolve),
            meta: {
                title: "收货人查询",
                keepAlive: true,
            },
        },
        {
            path: "/Customers/Consignor",
            component: (resolve) => require(["@/pages/Customers/Consignor"], resolve),
            meta: {
                title: "发货人查询",
                keepAlive: true,
            },
        },
        // 车辆管理
        {
            path: "/VMS/CarArchive",
            component: (resolve) => require(["@/pages/VMS/CarArchive"], resolve),
            meta: {
                title: "车辆档案",
                keepAlive: true,
            },
        },
        {
            path: "/VMS/DriverArchive",
            component: (resolve) => require(["@/pages/VMS/DriverArchive"], resolve),
            meta: {
                title: "司机档案",
                keepAlive: true,
            },
        },
        {
            path: "/VMS/GasArchive",
            component: (resolve) => require(["@/pages/VMS/GasArchive"], resolve),
            meta: {
                title: "油卡档案",
                keepAlive: true,
            },
        },
        {
            path: "/VMS/GasApply",
            component: (resolve) => require(["@/pages/VMS/GasApply"], resolve),
            meta: {
                title: "油卡申领记录",
                keepAlive: true,
            },
        },
        {
            path: "/VMS/VOCApply",
            component: (resolve) => require(["@/pages/VMS/VOCApply"], resolve),
            meta: {
                title: "车辆成本",
                keepAlive: true,
            },
        },
        {
            path: "/VMS/GasupRecord",
            component: (resolve) => require(["@/pages/VMS/GasupRecord"], resolve),
            meta: {
                title: "加油记录",
                keepAlive: true,
            },
        },
        {
            path: "/VMS/GascardEtc",
            component: (resolve) => require(["@/pages/VMS/GascardEtc"], resolve),
            meta: {
                title: "油卡充值",
                keepAlive: true,
            },
        },
        {
            path: "/VMS/GascardDaybook",
            component: (resolve) => require(["@/pages/VMS/GascardDaybook"], resolve),
            meta: {
                title: "油卡流水账",
                keepAlive: true,
            },
        },
    ]
}